import HttpService from '@bnr-dev/http-service/HttpService';
import TokenService from '@bnr-dev/token-service/TokenService';
import {getBackendHost} from "../../url.helper.js";

export default class ServiceContainer {
    private static instance: ServiceContainer;

    tokenService: TokenService;
    httpService: HttpService;

    // private constructor for singleton
    private constructor() {
        this.tokenService = new TokenService({
            accessTokenKey: 'BnrAccessToken',
            refreshTokenKey: 'BnrRefreshToken'
        });

        this.httpService = new HttpService(
            this.tokenService,
            getBackendHost() + "/ott-api/api/",
            [{ key: "BnrDevCorsEnabled", value: true }]);
    }

    public static getInstance(): ServiceContainer {
        if (!ServiceContainer.instance) {
            ServiceContainer.instance = new ServiceContainer();
        }

        return ServiceContainer.instance;
    }
}